import './App.scss';
import Footer from "./components/footer/footer";
const App = () => {
  return (
    <div className="App">
      <Footer />
    </div>
  );
}

export default App;
